import { SessionContext } from '@contexts/session-context';
import { UserPreferenceContext } from '@contexts/user-preference-context';
import { Feature } from '@enums/feature.enum';
import { useCallback, useContext } from 'react';

export const UseBaseHooks = () => {
  const { session } = useContext(SessionContext);
  const { userPreference } = useContext(UserPreferenceContext);
  const hasFeature = useCallback(
    (feature: Feature) => {
      return session.features.includes(feature);
    },
    [session],
  );

  const hasUserPreference = useCallback(
    (preference: string) => {
      return Boolean(userPreference.preference[preference]);
    },
    [userPreference],
  );

  const hasTenantPreference = useCallback(
    (preference: string) => {
      return Boolean(session.tenantPreference[preference]);
    },
    [session],
  );

  return {
    hasFeature,
    hasUserPreference,
    hasTenantPreference,
  };
};
